(()=>{function e(e){if(!e||e.disabled)return!1;const t=window.getComputedStyle(e);if("none"===t.display||"hidden"===t.visibility||e.hidden||"true"===e.getAttribute("aria-hidden"))return!1;const r=e.getBoundingClientRect();if(0===r.width||0===r.height)return!1;const o=n(e);if(0===o.width&&0===o.height)return!1;const i=e.getAttribute("tabindex");return!(null!==i&&parseInt(i,10)<0)&&"true"!==e.getAttribute("aria-disabled")}function t(t,n,r="forward"){if(!t.length)return null;let o=t.indexOf(n);if(-1===o){const e=t.find(e=>e.contains(n));o=t.indexOf(e)}let i=o;for(let n=0;n<t.length;n++){i="forward"===r?(i+1)%t.length:(i-1+t.length)%t.length;const n=t[i];if(e(n))return n.focus(),n}return null}function n(e){if(!e||function(e){if(!e)return!0;if(e.hidden)return!0;const t=window.getComputedStyle(e);return"none"===t.display||"hidden"===t.visibility||0===parseFloat(t.opacity)||!(!e.getAttribute||"true"!==e.getAttribute("aria-hidden"))}(e))return{width:0,height:0};if(e instanceof HTMLSlotElement){const t=e.assignedElements();for(const e of t){const t=n(e);if(t.width>0&&t.height>0)return t}return{width:0,height:0}}if(e.offsetWidth>0||e.offsetHeight>0)return{width:e.offsetWidth,height:e.offsetHeight};const t=e.getBoundingClientRect();if(t.width>0||t.height>0)return{width:t.width,height:t.height};for(const t of e.children){const e=n(t);if(e.width>0&&e.height>0)return e}return{width:0,height:0}}document.addEventListener("keydown",e=>{const n=document.querySelector('[role="dialog"][open], modal-dialog[open] .base-modal, modal-dialog[open] [role="dialog"], cart-drawer.active [role="dialog"], .popup-container.is-active');if(n){const r=Array.from(n.querySelectorAll('product-card, a[href]:not([tabindex="-1"]), button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"], [data-popup-toggle]')).filter(e=>!e.disabled&&null!==e.offsetParent);r[0],r[r.length-1];let o=document.activeElement;switch(o&&o.shadowRoot&&(o=o.shadowRoot.activeElement||o),e.key){case"Tab":if(e.shiftKey)e.preventDefault(),t(r,o,"backward");else{e.preventDefault();const n=document.activeElement;"false"==n.getAttribute("aria-expanded")?n.click():t(r,o,"forward")}break;case"Escape":e.preventDefault();const i=n.closest("[open], .is-active");i&&(i.hasAttribute("open")&&i.removeAttribute("open"),i.classList.contains("is-active")&&i.classList.remove("is-active"),document.documentElement.classList.remove("overflow-hidden"),document.documentElement.style.paddingRight="");break;case"Enter":const c=document.activeElement;c&&(c.hasAttribute("data-close")||c.hasAttribute("data-modal-close"))&&(e.preventDefault(),c.click())}return}if("Enter"===e.key){const t=document.activeElement;t&&"PRODUCT-CARD"===t.tagName&&(e.preventDefault(),t.click())}}),document.addEventListener("keydown",e=>{if("Space"===e.code||" "===e.key){const t=document.activeElement;t&&"VIDEO"===t.tagName&&(e.preventDefault(),t.paused?t.play():t.pause())}}),document.querySelectorAll("video").forEach(e=>{e.hasAttribute("tabindex")||(e.tabIndex=0)}),document.addEventListener("focusout",e=>{const t=e.target.closest(".dropdown-menu");if(!t)return;const n=e.relatedTarget||document.activeElement;if(!n||!t.contains(n)){const e=t.parentElement?.querySelector("summary");e&&e.click()}}),document.addEventListener("keydown",e=>{const t=e.target.closest(".product-variant-item");if(t&&(" "===e.key||"Enter"===e.key)){e.preventDefault();const n=t.querySelector('input[type="radio"]'),r=t.querySelector("label");return void(r?r.click():n&&!n.disabled&&(n.checked=!0,n.dispatchEvent(new Event("change",{bubbles:!0}))))}const n=e.target.closest(".swatch-input-container");if(n&&(" "===e.key||"Enter"===e.key)){e.preventDefault();n.querySelector('input[type="checkbox"]');const t=n.querySelector("label");return void(t&&t.click())}const r=e.target.closest("product-card-swatch");if(r&&(" "===e.key||"Enter"===e.key)){e.preventDefault();const t=r.closest("product-card");return void(t&&t.click())}const o=e.target.closest(".form__group-checkbox");if(o&&(" "===e.key||"Enter"===e.key)){e.preventDefault();o.querySelector('input[type="checkbox"]');const t=o.querySelector("label");return void(t&&t.click())}const i=e.target.closest(".form__group-radio");if(i&&(" "===e.key||"Enter"===e.key)){e.preventDefault();i.querySelector('input[type="radio"]');const t=i.querySelector("label");return void(t&&t.click())}const c=e.target.closest("facet-remove");!c||" "!==e.key&&"Enter"!==e.key||(e.preventDefault(),c.querySelector("a").click());const a=e.target.closest(".article-content, .extra-bar-text-message, .product__description-read-more, .action_muted, .hotspot, .tabs-actions .tab-title, .list-logo__item, .popup-newsletter-close, .popup-background-newsletter-close, .selector-item, .close-sidebar-filter");!a||" "!==e.key&&"Enter"!==e.key||(e.preventDefault(),a.click())})})();


// (() => {
//   const focusableSelector =
//     'product-card, a[href]:not([tabindex="-1"]), button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"], [data-popup-toggle]';
//   let lastTrigger = null;

//   document.addEventListener('keydown', (e) => {
//     const dialog = document.querySelector('[role="dialog"][open], modal-dialog[open] .base-modal, modal-dialog[open] [role="dialog"], cart-drawer.active [role="dialog"], .popup-container.is-active');
//     if (dialog) {
//       const focusables = Array.from(dialog.querySelectorAll(focusableSelector)).filter(el => !el.disabled && el.offsetParent !== null);
//       const first = focusables[0];
//       const last = focusables[focusables.length - 1];
//       let active = document.activeElement;
//       if (active && active.shadowRoot) active = active.shadowRoot.activeElement || active;

//       switch (e.key) {
//         case 'Tab':
//           //console.log(focusables);
//           if (e.shiftKey) {
//             e.preventDefault();
//             focusNext(focusables, active, 'backward');
//           } else {
//             e.preventDefault();
//             const el = document.activeElement;
//             if (el.getAttribute('aria-expanded') == 'false') el.click();
//             else focusNext(focusables, active, 'forward');
//           }
//           break;

//         case 'Escape':
//           e.preventDefault();
//           const openTarget = dialog.closest('[open], .is-active');
//           if (openTarget) {
//             if (openTarget.hasAttribute('open')) openTarget.removeAttribute('open');
//             if (openTarget.classList.contains('is-active')) openTarget.classList.remove('is-active');
//             document.documentElement.classList.remove('overflow-hidden');
//             document.documentElement.style.paddingRight = "";
//           }
//           if (lastTrigger) lastTrigger.focus();
//           break;

//         case 'Enter':
//           const el = document.activeElement;
//           if (el && (el.hasAttribute('data-close') || el.hasAttribute('data-modal-close'))) {
//             e.preventDefault();
//             el.click();
//             if (lastTrigger) lastTrigger.focus();
//           }
//           break;
//       }
//       return;
//     }

//     if (e.key === 'Enter') {
//       const el = document.activeElement;
//       if (el && el.tagName === 'PRODUCT-CARD') {
//         e.preventDefault();
//         el.click();
//       }
//     }
//   });

//   document.addEventListener('keydown', (e) => {
//     if (e.code === 'Space' || e.key === ' ') {
//       const active = document.activeElement;
//       if (active && active.tagName === 'VIDEO') {
//         e.preventDefault();
//         if (active.paused) active.play();
//         else active.pause();
//       }
//     }
//   });

//   document.querySelectorAll('video').forEach(v => {
//     if (!v.hasAttribute('tabindex')) v.tabIndex = 0;
//   });

//   function isNaturallyFocusable(el) {
//     return el.matches(
//       'a[href], area[href], input:not([type="hidden"]), select, textarea, button, iframe, object, embed, summary, [contenteditable]'
//     );
//   }

//   document.addEventListener('focusout', e => {
//     const dropdown = e.target.closest('.dropdown-menu');
//     if (!dropdown) return;

//     const next = e.relatedTarget || document.activeElement;
//     if (!next || !dropdown.contains(next)) {
//       const summary = dropdown.parentElement?.querySelector('summary');
//       if (summary) summary.click();
//     }
//   });

//   function isElementVisible(el) {
//     if (!el) return false;
//     if (el.hasAttribute('hidden')) return false;
//     const style = window.getComputedStyle(el);
//     if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return false;
//     const rects = el.getClientRects();
//     if (!rects || rects.length === 0) return false;
//     const r = rects[0];
//     if ((r.width === 0 && r.height === 0) || (r.bottom === 0 && r.right === 0 && r.top === 0 && r.left === 0)) return false;
//     let parent = el;
//     while (parent) {
//       if (parent !== el) {
//         if (parent.hasAttribute && parent.hasAttribute('hidden')) return false;
//         const pStyle = parent.nodeType === 1 ? window.getComputedStyle(parent) : null;
//         if (pStyle && (pStyle.display === 'none' || pStyle.visibility === 'hidden')) return false;
//         if (parent.hasAttribute && parent.hasAttribute('aria-hidden') && parent.getAttribute('aria-hidden') !== 'false') return false;
//         if (parent.inert) return false;
//       }
//       parent = parent.parentElement || (parent.getRootNode && parent.getRootNode().host) || null;
//     }
//     return true;
//   }

//   function isFocusable(el) {
//     if (!el || el.disabled) return false;
//     const style = window.getComputedStyle(el);
//     if (style.display === 'none' || style.visibility === 'hidden' || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
//     const rect = el.getBoundingClientRect();
//     if (rect.width === 0 || rect.height === 0) return false;
//     const size = getDisplayedSize(el);
//     if (size.width === 0 && size.height === 0) return false;
//     const t = el.getAttribute('tabindex');
//     if (t !== null && parseInt(t, 10) < 0) return false;
//     if (el.getAttribute('aria-disabled') === 'true') return false;
//     return true;
//   }

//   function focusNext(focusables, active, direction = 'forward') {
//     if (!focusables.length) return null;
//     let index = focusables.indexOf(active);
//     if (index === -1) {
//       const parent = focusables.find(f => f.contains(active));
//       index = focusables.indexOf(parent);
//     }
//     let nextIndex = index;
//     for (let i = 0; i < focusables.length; i++) {
//       nextIndex = direction === 'forward' ? (nextIndex + 1) % focusables.length : (nextIndex - 1 + focusables.length) % focusables.length;
//       const candidate = focusables[nextIndex];
//       if (isFocusable(candidate)) {
//         candidate.focus();
//         return candidate;
//       }
//     }
//     return null;
//   }

//   function getDisplayedSize(el) {
//     if (!el || isHiddenByCSS(el)) return { width: 0, height: 0 };
//     if (el instanceof HTMLSlotElement) {
//       const assigned = el.assignedElements();
//       for (const node of assigned) {
//         const size = getDisplayedSize(node);
//         if (size.width > 0 && size.height > 0) return size;
//       }
//       return { width: 0, height: 0 };
//     }
//     if (el.offsetWidth > 0 || el.offsetHeight > 0) return { width: el.offsetWidth, height: el.offsetHeight };
//     const rect = el.getBoundingClientRect();
//     if (rect.width > 0 || rect.height > 0) return { width: rect.width, height: rect.height };
//     for (const child of el.children) {
//       const size = getDisplayedSize(child);
//       if (size.width > 0 && size.height > 0) return size;
//     }
//     return { width: 0, height: 0 };
//   }

//   function isHiddenByCSS(el) {
//     if (!el) return true;
//     if (el.hidden) return true;
//     const style = window.getComputedStyle(el);
//     if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return true;
//     if (el.getAttribute && el.getAttribute('aria-hidden') === 'true') return true;
//     return false;
//   }

//   document.addEventListener('keydown', e => {
//     // --- Product variant item ---
//     const variantItem = e.target.closest('.product-variant-item');
//     if (variantItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       const radio = variantItem.querySelector('input[type="radio"]');
//       const label = variantItem.querySelector('label');
//       if (label) {
//         label.click();
//       } else if (radio && !radio.disabled) {
//         radio.checked = true;
//         radio.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//       return;
//     }
    
//     // --- filter swatch ---
//     const filterSwatchItem = e.target.closest('.swatch-input-container');
//     if (filterSwatchItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       const filterSwatch = filterSwatchItem.querySelector('input[type="checkbox"]');
//       const label = filterSwatchItem.querySelector('label');
//       if (label) {
//         label.click(); 
//       }
//       return;
//     }
    
//     // --- product swatch ---
//     const productSwatchItem = e.target.closest('product-card-swatch');
//     if (productSwatchItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       const productCard = productSwatchItem.closest('product-card');
//       if (productCard) {
//         productCard.click(); 
//       }
//       return;
//     }
    
//     // --- Checkbox group ---
//     const checkboxItem = e.target.closest('.form__group-checkbox');
//     if (checkboxItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       const checkbox = checkboxItem.querySelector('input[type="checkbox"]');
//       const label = checkboxItem.querySelector('label');
//       if (label) label.click(); 
//       return;
//     }

//     // --- Radio group ---
//     const radioItem = e.target.closest('.form__group-radio');
//     if (radioItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       const radio = radioItem.querySelector('input[type="radio"]');
//       const label = radioItem.querySelector('label');
//       if (label) label.click(); 
//       return;
//     }

//     // --- Facet remove ---
//     const facetItem = e.target.closest('facet-remove');
//     if (facetItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       facetItem.querySelector('a').click();
//     }

//     // --- Selector items & close button ---
//     const selectorItem = e.target.closest('.article-content, .extra-bar-text-message, .product__description-read-more, .action_muted, .hotspot, .tabs-actions .tab-title, .list-logo__item, .popup-newsletter-close, .popup-background-newsletter-close, .selector-item, .close-sidebar-filter');
//     if (selectorItem && (e.key === ' ' || e.key === 'Enter')) {
//       e.preventDefault();
//       selectorItem.click();
//     }
//   });

// })();
